<template>
  <div>
    <modal
      v-if="formatter"
      ref="formatterModal"
      id="agInputModal"
      class="modal-container"
      styles="display:flex; flex-direction:column; padding:15px;"
      :draggable=true
      :resizable=true
      :shiftX=.5
      :shiftY=0
      width="1114px"
      height="85%"
      v-model="showModal"
      name="formatter"
      drag="drag"
      content-class="modal-content"
      resize="resize"
      :fit-parent="true"
      :resize-directions="[ 'br']"
      :clickToClose="false"
      @keyup.enter.native="saveButton_click">
        <div>
          <h4 v-if="formatter._id" class="agModal-title">Edit Formatter</h4>
          <h4 v-else class="agModal-title">New Formatter</h4>
          <hr/>
        </div>
        <div class="inner" style="height: 100%; overflow-y: auto; overflow-x:hidden; position:relative;">
        <div class="agInputGroup agInputGroupCentered">
          <label>Source:</label>
          <b-input
            type="text"
            :value="srcStr"
            autocomplete="false"
            disabled
          ></b-input>
        </div>
        <b-input-group style="padding:14px;" size="md" prepend="Name">
          <b-input
            type="text"
            v-model="formatter.name"
            autocomplete="false"
            :disabled="disableUI"
          ></b-input>
        </b-input-group>
        <b-input-group style="padding:14px;" size="md" prepend="Description">
          <b-input
            type="text"
            v-model="formatter.description"
            autocomplete="false"
            :disabled="disableUI"
          ></b-input>
        </b-input-group>
        <hr />
        <div class="agInputGroup agInputGroupCentered">
          <label>Format Type:</label>
          <b-form-select
            class="agSmallInput"
            v-model="formatter.subtype"
            :options="formatTypes"
            :disabled="disableUI"
            @change="typeField_change"
          >
          </b-form-select>
        </div>
        <div style="padding:4px;" class="agInputGroup agInputGroupCentered">
          <div class="agInputGroup agInputGroupInline">
            <label>In Field:</label>
            <b-form-select
              :key="'outFields-' + reloadFields"
              class="agLargeInput"
              v-model="formatter.inField"
              :disabled="disableUI || inFieldDisabled"
              @change="field_change($event, 'inField')"
            >
              <optgroup v-for="(field, key) in fields" :key="key" :label="key">
                <option
                  v-for="(option, index) in field"
                  :key="index"
                  :value="option.value"
                  >{{ option.text }}</option
                >
              </optgroup>
            </b-form-select>
          </div>
          <div class="agInputGroup agInputGroupInline">
            <label>Out Field:</label>
            <b-form-select
              :key="'outFields-' + reloadFields"
              class="agLargeInput"
              v-model="formatter.outField"
              :disabled="disableUI"
              @change="field_change($event, 'outField')"
            >
              <optgroup v-for="(field, key) in fields" :key="key" :label="key">
                <option
                  v-for="(option, index) in field"
                  :key="index"
                  :value="option.value"
                  >{{ option.text }}</option
                >
              </optgroup>
            </b-form-select>
          </div>
        </div>
        <hr />

        <!-- Components based on type -->
        <ag-bigTextFormatter
          v-if="currentType == 'bigText'"
          ref="bigText"
          :disableUI="disableUI"
          :formatter="formatter"
          :workflow="workflow"
        >
        </ag-bigTextFormatter>
        <ag-castFormatter
          v-if="currentType == 'cast'"
          ref="cast"
          :disableUI="disableUI"
          :formatter="formatter"
        >
        </ag-castFormatter>
        <ag-dateFormatter
          v-if="currentType == 'date'"
          ref="date"
          :disableUI="disableUI"
          :formatter="formatter"
        >
        </ag-dateFormatter>
        <ag-geoFormatter
          v-if="currentType == 'geo'"
          ref="geo"
          :disableUI="disableUI"
          :formatter="formatter"
          :workflow="workflow"
          :fields="fields"
        >
        </ag-geoFormatter>
        <ag-mathFormatter
          v-if="currentType == 'math'"
          ref="math"
          :disableUI="disableUI"
          :formatter="formatter"
          :workflow="workflow"
        >
        </ag-mathFormatter>
        <ag-substringFormatter
          v-if="currentType == 'substring'"
          ref="substring"
          :disableUI="disableUI"
          :formatter="formatter"
        >
        </ag-substringFormatter>
        <ag-hashFormatter
          v-if="currentType == 'hash'"
          ref="hash"
          :disableUI="disableUI"
          :formatter="formatter"
          :workflow="workflow">
        </ag-hashFormatter>

        <ag-geoJsonFormatter
          v-if="currentType == 'geoJson'"
          ref="geoJson"
          :disableUI="disableUI"
          :formatter="formatter"
          :workflow="workflow">
        </ag-geoJsonFormatter>

        <hr />
        <div class="agInputGroup agInputGroupCentered">
          <label>Destination:</label>
          <b-input
            type="text"
            :value="destName"
            autocomplete="false"
            disabled
          ></b-input>
        </div>
        <div v-if="modalMessage">
          <hr />
          <label class="agModal-message" :class="modalMessageClass">{{
            modalMessage
          }}</label>
        </div>
      </div>
      <div>
        <hr/>
        <b-button class="agModal-buttonLeft" @click="cancelButton_click"
          >Cancel</b-button
        >
        <b-spinner v-if="isLoading" class="agModal-loadingSpinner"></b-spinner>
        <b-button
          class="agModal-buttonRight"
          variant="danger"
          :disabled="disableUI || isLoading"
          @click="deleteButton_click"
          style="margin-left: 82%;"
          >Delete</b-button
        >
        <b-button
          class="agModal-buttonRight"
          variant="primary"
          :disabled="disableUI || isLoading"
          @click="saveButton_click"
          style="float:right;"
          >Save</b-button
        >
      </div>

      <!-- delete modal -->
      <b-modal
        class="agModal"
        ref="deleteModal"
        centered
        no-close-on-esc
        no-close-on-backdrop
        @keyup.enter.native="deleteButton_click"
      >
        <template slot="modal-header">
          <h4 class="agModal-title danger">Delete Formatter</h4>
        </template>
        Are you sure you want to delete formatter
        <i>{{ name }}</i
        >?
        <template slot="modal-footer" slot-scope="{ cancel }">
          <b-button class="agModal-buttonLeft" @click="cancel"
            >Cancel</b-button
          >
          <b-button
            class="agModal-buttonRight"
            variant="danger"
            @click="confirmDeleteButton_click"
            >Delete</b-button
          >
        </template>
      </b-modal>
    </modal>
  </div>
</template>

<script>
// components
import BigTextFormatter from "nodes/formatters/BigTextFormatter";
import CastFormatter from "nodes/formatters/CastFormatter";
import DateFormatter from "nodes/formatters/DateFormatter";
import GeoFormatter from "nodes/formatters/GeoFormatter";
import MathFormatter from "nodes/formatters/MathFormatter";
import SubstringFormatter from "nodes/formatters/SubstringFormatter";
import HashFormatter from "nodes/formatters/HashFormatter";
import GeoJSONFormatter from "nodes/formatters/GeoJSONFormatter.vue";
import _ from "lodash";

// modules
import Server from "src/server";
import Util from "src/util/util";

export default {
  name: "ag-formatter-modal",

  components: {
    "ag-bigTextFormatter": BigTextFormatter,
    "ag-castFormatter": CastFormatter,
    "ag-dateFormatter": DateFormatter,
    "ag-geoFormatter": GeoFormatter,
    "ag-mathFormatter": MathFormatter,
    "ag-substringFormatter": SubstringFormatter,
    "ag-hashFormatter": HashFormatter,
    "ag-geoJsonFormatter":GeoJSONFormatter
  },

  props: {
    node: Object,
    workflow: Object,
    disableUI: Boolean
  },

  data() {
    return {
      showModal: false,
      formatter: null,
      isLoading: false,
      reloadFields: 0,
      modalMessage: "",
      modalMessageClass: "",
      fields: {},
      currentType: "",
      formatTypes: [
        { value: "bigText", text: "Big Text" },
        { value: "cast", text: "Cast" },
        { value: "date", text: "Date" },
        { value: "geo", text: "Geometry" },
        { value: "math", text: "Math" },
        { value: "substring", text: "Substring" },
        { value: "lowercase", text: "To Lowercase" },
        { value: "uppercase", text: "To Uppercase" },
        { value: "trim", text: "Trim" },
        { value: "urlencode", text: "URL Encode" },
        { value: "hash", text: "Hash" },
        { value:"geoJson", text:"GeoJSON" }
      ]
    };
  },

  computed: {
    name() {
      if (this.formatter.name) {
        return this.formatter.name;
      }
      return this.formatter.shortname;
    },

    srcStr() {
      if (!this.formatter.src || this.formatter.src.length == 0) return "";

      var srcStr = "";
      for (var i = 0; i < this.formatter.src.length; i++) {
        var src = this.formatter.src[i];
        srcStr += src.shortname + ", ";
      }
      srcStr = srcStr.substring(0, srcStr.length - 2); // remove the last ,
      return srcStr;
    },

    destName() {
      if (this.formatter.dest) return this.formatter.dest.shortname;
      return "";
    },

    inFieldDisabled() {
      if (
        this.formatter.subtype == "bigText" ||
        this.formatter.subtype == "math" ||
        this.formatter.subtype == "geo" ||
        this.formatter.subtype == "hash" 
      ) {
        this.formatter.inField = null;
        return true;
      }
      return false;
    }
  },

  watch: {},

  created() {},

  mounted() {},

  methods: {
    // UI Events
    cancelButton_click() {
      this.$modal.hide('formatter');

    },
    async saveButton_click() {
      this.modalMessage = "";

      // alert subcomponent
      var subcomponent = this.$refs[this.formatter.subtype];
      if (subcomponent) subcomponent.prepareForSave();

      var node = {
        object: this.formatter,
        type: "formatter"
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/updateNode", {
        node: node
      });
      this.isLoading = false;
      if (result.data.success) {
        var updated = {
          type: "formatter",
          object: result.data.node
        };
        this.hide("formatter");
        this.$emit("updatedNode", updated);
      } else {
        this.modalMessage = result.data.error;
        this.modalMessageClass = "agModal-errorMessage";
      }
    },

    deleteButton_click() {
      this.$refs.deleteModal.show();
    },

    async confirmDeleteButton_click() {
      this.$refs.deleteModal.hide();
      var node = {
        object: this.formatter,
        type: "formatter"
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/deleteNode", {
        node: node
      });
      this.$emit("deletedNode", node);
      this.isLoading = false;
      this.hide("formatter");
    },

    typeField_change() {
      this.formatter.config = {};
      this.currentType = this.formatter.subtype;
    },

    field_change(value, field) {
      if (value.field == "-- None --") this.formatter[field] = null;
    },

    // emitted Events

    // other

    show() {
      this.setFormatter();
      this.showModal = true;
      setTimeout(() => {
        this.reset();
        // const container = document.getElementsByClassName(
        //   "vfm__content modal-content"
        // );
        // container[0].style =
        //   "max-height:70%;min-height:50%; max-width: 84%; min-width:66%;";
        // this.$vfm.show("formatter");
        this.$modal.show('formatter',{ draggable: true });
      }, 250);
    },
    hide(arg) {
      if (arg !== undefined) {
        this.$modal.hide(arg);
      } else {
        this.$modal.hide('formatter');
      }
    },

    reset() {
      this.modalMessage = "";
      this.modalMessageClass = "";
      this.errorField = "";
      this.currentType = this.formatter.subtype;

      this.setFields();
      this.reloadFields++;

      var self = this;
      setTimeout(() => {
        var subcomponent = self.$refs[self.formatter.subtype];
        if (subcomponent) subcomponent.reset();
      }, 250);
    },

    setFormatter() {
      if (this.node && this.node.type == "formatter")
        this.formatter = this.workflow.formatters.find(
          object => object._id == this.node.object._id
        );
      else this.formatter = null;
    },

    setFields() {
      var inputFields = Util.getInputFields(this.$store, this.workflow);
      this.fields = Util.fieldsToOptionGroups(inputFields);
    }
  }
};
</script>

<style scoped lang="css">
.vfm__content modal-content{
  max-height:70%;
  min-height:50%; 
  max-width: 84%; 
  min-width:50%; 
  margin-top:10%;
}

</style>



// WEBPACK FOOTER //
// src/components/nodes/formatters/FormatterModal.vue